import { usePostDesignsMutation } from '@/api/serverApi'
import { Button, PlusIcon } from '@cfs-fixings/shared'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const textSpec = {
  header: 'No designs found.',
  description: 'Click below to create a new design',
  buttonLabel: 'Create a new design',
}

type PropTypes = {
  projectId?: string
  descriptionOverride?: string
}

const NoDesignsDisplay = ({ projectId, descriptionOverride }: PropTypes) => {
  const navigate = useNavigate()

  const [isCreatingDesign, setIsCreatingDesign] = useState(false)

  const [createDesign] = usePostDesignsMutation()

  const handleCreateDesign = () => {
    setIsCreatingDesign(true)

    const body = projectId ? { project_id: projectId } : {}

    createDesign({ body: body })
      .unwrap()
      .then(result => {
        return navigate(`/designs/${result.data.id}`)
      })
      .catch(() => {
        setIsCreatingDesign(false)
      })
  }

  return (
    <div className="mx-2.5 py-8 text-center flex flex-col gap-4 border border-dotted border-gray-100 rounded">
      <h2 className="text-xl leading-6 font-medium px-2.5">{textSpec.header}</h2>
      <p>{descriptionOverride ?? textSpec.description}</p>
      <div className="flex justify-center">
        <Button
          onClick={handleCreateDesign}
          isLoading={isCreatingDesign}
          variant="outline"
        >
          <div className="flex items-center">
            <PlusIcon className="w-[8px] h-[8px] mr-[7px]" />
            <span>{textSpec.buttonLabel}</span>
          </div>
        </Button>
      </div>
    </div>
  )
}

export default NoDesignsDisplay
